<form #mapForm="ngForm" autocomplete="off" [formGroup]="confirmationControl" >
  <mat-form-field  class="fullWidth">
    <mat-label>User name</mat-label>
    <input matInput required [(ngModel)]="data.userName" name="user-name" maxlength="255"
           formControlName="userName" autocomplete="new-password">
    <mat-error>
      Username is <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field class="fullWidth">
    <mat-label>Password</mat-label>
    <input type="password" formControlName="password" matInput [(ngModel)]="data.password" name="password"
           pattern="(?=.*[a-zA-Z].*)(?=.*\d.*)\S{8,20}" required autocomplete="new-password">
    <mat-error>Invalid password</mat-error>
  </mat-form-field>

  <mat-form-field class="fullWidth">
    <mat-label>Confirm password</mat-label>
    <input type="password" formControlName="confirm-password" required matInput [(ngModel)]="data.passwordConfirm" name="confirm-password"
           [errorStateMatcher]="matcher" autocomplete="new-password">
    <mat-error *ngIf="confirmationControl.errors?.mismatch">Confirm password does not match Password</mat-error>
  </mat-form-field>

  <ac-input-container label="Type">
    <ac-select [acModel]="data.type"
               [searchable]="false"
               [ngDisabled]="isEdit"
               alternativeName="credentials.role"
               (acModelChange)="data.type = $event"
               [items]="typeOptionList">
    </ac-select>
  </ac-input-container>

  <div class="password-rules-container">
    <mat-label class="password-rule-item">The password length must be between 8 and 20.</mat-label>
    <mat-label class="password-rule-item">Must contain at least one letter and one digit.</mat-label>
  </div>

</form>
